import { instance } from "@/api/index";

export const getEmp = () => instance.get("/back/common/getEmpList"); // 사원조회
export const uploadFile = payload => instance.post("/file/upload", payload); // 첨부파일 업로드
// 첨부파일 다운로드
export const downloadFile = payload =>
  instance.get(`/file/download/${payload}`, {
    responseType: "arraybuffer",
  });

// login
export const login = token => instance.get(`/api/login?accesstoken=${token}`);
